import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useRouter } from "next/router";
import { useTranslation } from "next-i18next";

import { supportActions } from "@sellernote/shipda-kr/src/modules/support";
import { useAppSelector } from "@sellernote/shipda-kr/src/store";
import BoardCategory from "@sellernote/ui/src/sds-v1/components/board/BoardCategory";
import Loading from "@sellernote/ui/src/sds-v1/components/Loading";

export default function GuideCategoryList() {
  const { t } = useTranslation(["support-new"]);

  const router = useRouter();

  const { id } = router.query;

  const dispatch = useDispatch();

  const { useList, tradeTermsList, faqList } = useAppSelector((state) => {
    return {
      useList: state.support.GET_HOW_TO_LIST.data?.list,
      tradeTermsList: state.support.GET_TERMS_LIST.data?.list,
      faqList: state.support.GET_FAQ_LIST.data?.list,
    };
  });

  useEffect(() => {
    if (id) {
      fetchList();
    }

    return () => {
      dispatch(supportActions.INIT_GET_HOW_TO_LIST({}));
      dispatch(supportActions.INIT_GET_TERMS_LIST({}));
      dispatch(supportActions.INIT_GET_FAQ_LIST({}));
    };
  }, [id]);

  const hasRequiredData = useList && tradeTermsList && faqList;

  if (!hasRequiredData)
    return (
      <Loading active={!hasRequiredData} label={t("support-new:공통_로딩")} />
    );

  function fetchList() {
    const params = { page: 0, perPage: 10 };

    dispatch(supportActions.GET_HOW_TO_LIST(params));
    dispatch(supportActions.GET_TERMS_LIST(params));
    dispatch(supportActions.GET_FAQ_LIST(params));
  }

  return (
    <BoardCategory
      title={t("support-new:공통_쉽다_가이드")}
      type="categoryList"
      categoryList={[
        {
          boardTitle: t("support-new:공통_이용방법"),
          boardHref: "/support/guide/use",
          boardList: useList,
        },
        {
          boardTitle: t("support-new:공통_무역용어_운송프로세스"),
          boardHref: "/support/guide/tradeterms",
          boardList: tradeTermsList,
        },
        {
          boardTitle: "FAQ",
          boardHref: "/support/guide/faq",
          boardList: faqList,
        },
      ]}
      currentContentsId={Number(id)}
    />
  );
}
